/** @jsx jsx */
import { Fragment, useState } from 'react';
import { NextPage } from 'next';
import { field, useForm, useSubmit, validate } from '@balance-web/forms';
import { jsx } from '@balance-web/core';
import { Flex } from '@balance-web/flex';
import { Text } from '@balance-web/text';
import { Button } from '@balance-web/button';
import { Box } from '@balance-web/box';
import { Notice } from '@balance-web/notice';

import { SelectField } from '../generic/SelectField';
import { TextField } from '../generic/TextField';

// FIXME: Move to constants
const regionOptions = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
] as const;

// FIXME: Replace `any` declarations
export const SignUpForm: NextPage<{
  onsubmit?: any;
  errorMessage?: string;
  setErrorMessage?: any;
  registered?: boolean;
  setRegistered?: any;
  // children: ReactNode;
}> = ({
  onsubmit,
  errorMessage,
  setErrorMessage,
  registered,
  setRegistered,
  // children,
}) => {
  const [region, setRegion] = useState(getSelectInitialValue(regionOptions, 0));
  let signUpForm = field.object({
    email: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your email');
        return value;
      }),
    }),
    firstname: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your firstname');
        return value;
      }),
    }),
    lastname: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your lastname');
        return value;
      }),
    }),
    phonenumber: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your phone number');
        return value;
      }),
    }),
    password: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your password');
        return value;
      }),
    }),
  });

  let form = useForm(signUpForm);
  const submit = useSubmit(form, async (value) => {
    if (
      !value.email ||
      !value.firstname ||
      !value.lastname ||
      !value.phonenumber ||
      !region ||
      !value.password
    )
      return;
    onsubmit(value, region);
    // setRegistered(true);
  });
  return (
    <Fragment>
      <form
        id="signup-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        {errorMessage ? (
          <Box paddingBottom="xlarge">
            <Notice tone="critical">
              {errorMessage ? <Text>{errorMessage}</Text> : ''}
            </Notice>
          </Box>
        ) : null}

        {registered ? (
          <div>
            <h2>Successfully Registered</h2>
            <h4>
              Activate your Account! Please check your email for an activation
              link.
            </h4>
          </div>
        ) : (
          <Flex
            direction="column"
            gap="medium"
            alignItems="center"
            padding="xlarge"
          >
            <Box
              paddingX="large"
              paddingY="medium"
              borderRadius="small"
              width={400}
            >
              <TextField
                type="text"
                label="Email"
                placeholder="Enter email"
                {...form.fields.email.props}
              />
              <TextField
                type="text"
                label="Firstname"
                placeholder="Enter First Name"
                {...form.fields.firstname.props}
              />
              <TextField
                type="text"
                label="Lastname"
                placeholder="Enter Last Name"
                {...form.fields.lastname.props}
              />
              <TextField
                type="text"
                label="Phone"
                placeholder="Enter Phone"
                {...form.fields.phonenumber.props}
              />
              <SelectField
                onChange={setRegion}
                value={region}
                label="Country"
                options={regionOptions}
              />
              <TextField
                type="password"
                label="Password"
                placeholder="Enter password"
                {...form.fields.password.props}
              />

              <Box marginTop="medium">
                <Button
                  id="login"
                  disabled={form.validity !== 'valid'}
                  type="submit"
                  size="medium"
                  block
                  label="Register"
                />
              </Box>
            </Box>
          </Flex>
        )}
      </form>
    </Fragment>
  );
};

// FIXME: Move to utils
function getSelectInitialValue<T>(
  options: Readonly<{ label: string; value: T }[]>,
  index?: number
) {
  if (typeof index === 'number') {
    return options[index].value;
  }

  return undefined;
}
